import Vue from 'vue'
import App from './App.vue'
import language from './plugins/i18n/main'
import router from './plugins/router'
import store from './store/main'
import './plugins/flash-message'
import './plugins/font-awesome-icon'
import './plugins/bootstrap-vue'
import './plugins/apexcharts'
import VueFullscreen from 'vue-fullscreen'
import VueBarcodeScanner from 'vue-barcode-scanner'
import './assets/css/tailwind.css'

Vue.use(VueBarcodeScanner)

Vue.config.productionTip = false

window.i18n = language.i18n
window.i18nHelper = language.i18nHelper

Vue.prototype.$i18nHelper = window.i18nHelper;

Vue.use(VueFullscreen)
new Vue({
    data: {
        showOverlay: false,
        showSidebar: false,
    },

    i18n: language.i18n,
    router,
    store,
    render: h => h(App)
}).$mount('#app');
